'use client';

import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  text?: string;
  showText?: boolean;
  className?: string;
}

export default function LoadingSpinner({ 
  size = 'medium', 
  color = '#000000',
  text = '加载中...',
  showText = true,
  className = ''
}: LoadingSpinnerProps) {
  // 根据size确定图标尺寸
  const getIconSize = () => {
    switch (size) {
      case 'small':
        return '20px';
      case 'medium':
        return '30px';
      case 'large':
        return '40px';
      default:
        return '30px';
    }
  };

  const iconSize = getIconSize();

  return (
    <div 
      className={className}
      style={{ 
        display: 'flex', 
        flexDirection: showText ? 'column' : 'row',
        alignItems: 'center', 
        justifyContent: 'center',
        gap: showText ? '1rem' : '0.5rem'
      }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{
          animation: 'spin 1s linear infinite'
        }}
      >
        <path d="M21 12a9 9 0 11-6.219-8.56"/>
      </svg>
      {showText && (
        <div style={{ 
          fontSize: '0.875rem',
          color: '#666666'
        }}>
          {text}
        </div>
      )}
      <style jsx>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
} 